import { Component, OnInit } from '@angular/core';
import {Meta} from "@angular/platform-browser";

@Component({
  selector: 'pmui-set-password-success-view',
  templateUrl: './set-password-success-view.component.html',
  styleUrls: ['./set-password-success-view.component.less']
})
export class SetPasswordSuccessViewComponent implements OnInit {

  constructor(private meta: Meta) { }

  ngOnInit() {
      // Set meta tags to prevent indexing
      // The robots meta tag instructs search engines not to show the page in search results
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
  }

}
